(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vega-cumple-codigo"] && !Shopify.designMode) return;
  try {
    
  /* VEGA: copiar el código de cumpleaños al portapapeles con feedback breve. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.vcc__code') : null;
    if (!btn) return;
    var code = btn.getAttribute('data-code');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(code).then(function () {
      var hint = btn.querySelector('.vcc__copy-hint');
      if (!hint) return;
      var prev = hint.textContent;
      hint.textContent = '¡Copiado!';
      setTimeout(function () { hint.textContent = prev; }, 1600);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-puntos"] && !Shopify.designMode) return;
  try {
    
  /* VEGA: copiar el código de canje al portapapeles con feedback breve. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.vpt__code') : null;
    if (!btn) return;
    var code = btn.getAttribute('data-code');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(code).then(function () {
      var hint = btn.querySelector('em');
      if (!hint) return;
      var prev = hint.textContent;
      hint.textContent = '¡Copiado!';
      setTimeout(function () { hint.textContent = prev; }, 1600);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
